import { List, Button, Spin, Alert, Space } from "antd";
import { BILL_RZP_LINK_GEN } from "../../../constants/api";
import { ERROR_MSG_TYPE, SUCCESS_MSG_TYPE } from "../../../constants/messages";
import { useState } from "react";
import { displayMessage, exPostAPI } from "../../../utils/common";
import { CURRENCY } from "../../../constants/constent";
import { ReloadOutlined, LogoutOutlined } from "@ant-design/icons";

const VendorBills = ({
  vendorBills,
  loadingBills,
  getVendorBill,
  enableLogin,
  handleLogout,
}) => {
  const [buttonLoading, setButtonLoading] = useState(false);

  const isSystemBlocked = vendorBills?.some((bill) => bill.show_error === true);
  const blockedBill = vendorBills?.find((bill) => bill.show_error === true);
  const pendingTransaction = blockedBill?.transactions?.find(
    (t) => t.payment_status === "pending" && t.payment_link,
  );

  const genratePaymentLink = (bill) => {
    setButtonLoading(true);

    const successFn = (data) => {
      setButtonLoading(false);
      if (data.status && data.data) {
        getVendorBill();
        displayMessage(SUCCESS_MSG_TYPE, data.message);
      } else {
        getVendorBill();
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };

    const errorFn = () => {
      setButtonLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to generate the link.");
    };

    exPostAPI(
      `${BILL_RZP_LINK_GEN}`,
      {
        vendor_id: bill.vendor_id,
        vendor_bill_id: bill.id,
        amount: bill.total_rest_amount,
      },
      successFn,
      errorFn,
    );
  };

  return (
    <>
      {/* Overlay if system blocks bills */}
      {isSystemBlocked && blockedBill && !buttonLoading && (
        <div style={overlayStyles}>
          <div style={overlayContentStyles}>
            <div
              style={{
                fontSize: "60px",
                marginBottom: "20px",
                animation: "shake 0.8s infinite",
              }}
            >
              🔒
            </div>
            <h2 style={{ marginBottom: "15px", color: "#fff" }}>
              Account Temporarily Blocked
            </h2>
            <p
              style={{
                marginBottom: "25px",
                color: "rgba(255,255,255,0.85)",
                fontSize: "16px",
              }}
            >
              {blockedBill.error_message}
            </p>

            <Space>
              {blockedBill.bill_status === "pending" &&
              pendingTransaction?.payment_status === "pending" &&
              pendingTransaction?.payment_link ? (
                <a
                  href={pendingTransaction.payment_link}
                  target="_blank"
                  rel="noreferrer"
                >
                  <Button
                    type="primary"
                    size="large"
                    loading={buttonLoading}
                    disabled={buttonLoading}
                    style={payButtonStyles}
                  >
                    Pay Now & Unlock
                  </Button>
                </a>
              ) : (
                <Button
                  onClick={() => genratePaymentLink(blockedBill)}
                  type="primary"
                  size="large"
                  loading={buttonLoading}
                  disabled={buttonLoading}
                  style={payButtonStyles}
                >
                  Generate Payment Link
                </Button>
              )}
              <Button
                onClick={getVendorBill}
                loading={buttonLoading}
                disabled={buttonLoading}
                style={reloadButtonStyles}
              >
                <ReloadOutlined />
              </Button>
            </Space>
          </div>
        </div>
      )}

      {/* Overlay if enable_login is false */}
      {!enableLogin && (
        <div style={overlayStyles}>
          <div style={overlayContentStyles}>
            <div
              style={{
                fontSize: "60px",
                marginBottom: "20px",
                animation: "shake 0.8s infinite",
              }}
            >
              ❌
            </div>
            <h2 style={{ marginBottom: "15px", color: "#fff" }}>
              Account Blocked
            </h2>
            <p
              style={{
                marginBottom: "25px",
                color: "rgba(255,255,255,0.85)",
                fontSize: "16px",
              }}
            >
              Your account has been blocked by the system administrator. Please
              contact support for assistance.
            </p>
            <Space>
              <Button
                type="primary"
                size="large"
                onClick={handleLogout}
                icon={<LogoutOutlined />}
                style={payButtonStyles}
              >
                Logout
              </Button>
              <Button
                onClick={getVendorBill}
                loading={buttonLoading}
                disabled={buttonLoading}
                style={reloadButtonStyles}
              >
                <ReloadOutlined />
              </Button>
            </Space>
          </div>
        </div>
      )}

      {/* Optional CSS animation for lock/shake */}
      <style>
        {`
          @keyframes shake {
            0% { transform: rotate(0deg); }
            25% { transform: rotate(5deg); }
            50% { transform: rotate(0deg); }
            75% { transform: rotate(-5deg); }
            100% { transform: rotate(0deg); }
          }
        `}
      </style>
      <Spin spinning={loadingBills}>
        {/* Vendor bills list */}
        {Array.isArray(vendorBills) && vendorBills.length > 0 && (
          <List
            dataSource={vendorBills}
            renderItem={(bill) => {
              const pendingTransaction = bill.transactions.find(
                (t) => t.payment_status === "pending" && t.payment_link,
              );

              const alertType = bill.show_error
                ? "error"
                : bill.show_warning
                  ? "warning"
                  : "info";

              const billColor = bill.show_error
                ? bill.error_color_code
                : bill.show_warning
                  ? bill.warning_color_code
                  : bill.info_color_code;

              return (
                <List.Item key={bill.id}>
                  <div style={{ width: "100%" }}>
                    <Alert
                      banner
                      type={alertType}
                      showIcon
                      style={{ backgroundColor: billColor }}
                      message={
                        <>
                          <strong>
                            {bill.invoice_no} ({bill.bill_type.toUpperCase()}) —{" "}
                            {CURRENCY}
                            {bill.bill_amount}
                          </strong>
                        </>
                      }
                      description={
                        bill.error_message ||
                        bill.warning_message ||
                        bill.info_message ||
                        "Payment pending"
                      }
                      action={
                        <Space>
                          {pendingTransaction ? (
                            <a
                              href={pendingTransaction.payment_link}
                              target="_blank"
                              rel="noreferrer"
                            >
                              <Button
                                loading={buttonLoading}
                                disabled={buttonLoading}
                                type="primary"
                              >
                                Pay Now
                              </Button>
                            </a>
                          ) : (
                            <Button
                              onClick={() => genratePaymentLink(bill)}
                              loading={buttonLoading}
                              disabled={buttonLoading}
                              type="default"
                            >
                              Generate Payment Link
                            </Button>
                          )}
                          <Button
                            onClick={getVendorBill}
                            loading={buttonLoading}
                            disabled={buttonLoading}
                            icon={<ReloadOutlined />}
                          />
                        </Space>
                      }
                    />
                  </div>
                </List.Item>
              );
            }}
          />
        )}
      </Spin>
    </>
  );
};

// Shared styles
const overlayStyles = {
  position: "fixed",
  inset: 0,
  background: "rgba(0, 0, 0, 0.7)",
  backdropFilter: "blur(8px) saturate(120%)",
  WebkitBackdropFilter: "blur(8px) saturate(120%)",
  zIndex: 9999,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: "20px",
};

const overlayContentStyles = {
  background: "rgba(255, 255, 255, 0.15)",
  borderRadius: "16px",
  padding: "50px 30px",
  width: "100%",
  maxWidth: "500px",
  textAlign: "center",
  boxShadow: "0 20px 40px rgba(0,0,0,0.4)",
  border: "1px solid rgba(255,255,255,0.2)",
  backdropFilter: "blur(10px)",
};

const payButtonStyles = {
  padding: "10px 30px",
  fontSize: "16px",
  borderRadius: "8px",
  background: `linear-gradient(135deg, var(--primary-color), var(--secondary-color))`,
  border: "none",
  boxShadow: "0 5px 15px rgba(0,0,0,0.3)",
};

const reloadButtonStyles = {
  padding: "20px 12px",
  fontSize: "16px",
  borderRadius: "8px",
  background: `linear-gradient(135deg, var(--primary-color), var(--primary-color))`,
  border: "none",
  boxShadow: "0 5px 15px rgba(0,0,0,0.3)",
};

export default VendorBills;
